const _excluded = ["id", "issueTypeID", "reportID", "version"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createHashHistory } from 'history';
import changeActionFactory from './factories/changeActionFactory';
import contentChangeActionFactory from './factories/contentChangeActionFactory';
import entityActionFactory from './factories/entityActionFactory';
import issueConstants from '../constants/issueConstants';
import uploadActionFactory from './factories/uploadActionFactory';
import tokenErrorActions from './tokenErrorActionCreators';
import notificationActions from './notificationActionCreators';
import { post, remove } from './ajax';

// define the basic actions, and include page and change actions.
const changeActions = changeActionFactory('issue', 'issues');
const entityActions = entityActionFactory('issue', 'issues');
const contentChangeActions = contentChangeActionFactory('issue', 'issues');
const uploadActions = uploadActionFactory('issue', 'issues', true, 'Photo');
const hashHistory = createHashHistory();
const includedActions = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, changeActions), entityActions), uploadActions), contentChangeActions);
const handleRedirect = (dispatch, getState) => {
  const entityState = getState().issue;
  dispatch(entityActions.serverIndex(entityState.indexQuery, true, true));
  hashHistory.push('issues');
};
const serverSave = (version, handleRedirectIn, postOpts) => contentChangeActions.serverSave(version, handleRedirectIn || handleRedirect, postOpts);
/**
 * indexByReport
 * @param data
 * arguments are a reportID and name (reportType identifier and reportNumber combined):
 * reportID: 'some-report-uuid',
 * reportName: 'Daily Inspection Report 1'
 */
const indexByReport = (reportID, reportName, indexQuery) => ({
  type: issueConstants.INDEX_BY_REPORT,
  reportID,
  reportName,
  indexQuery
});
const createIssuePhoto = (id, createdDate, issuePhotos, activeID, userID) => {
  // create a new issuePhoto object
  const photo = {
    id,
    created: createdDate,
    modified: createdDate,
    metaDeleted: 0,
    appCreated: createdDate,
    appCreatorID: userID,
    issueID: activeID
  };

  // attach new issuePhoto to active issue
  issuePhotos.push(photo);
  return includedActions.change(activeID, 'issuePhotos', issuePhotos);
};
const serverCreateIssue = (patch, navigate = () => {}) => dispatch => {
  const _patch$patch = patch.patch,
    {
      id,
      issueTypeID,
      reportID,
      version
    } = _patch$patch,
    secondaryPatch = _objectWithoutProperties(_patch$patch, _excluded);
  return dispatch(contentChangeActions.serverSaveMergePatches(id, [{
    id,
    patch: {
      issueTypeID,
      reportID,
      id,
      version
    }
  }, {
    id,
    patch: secondaryPatch
  }], (savedID, data) => dispatcher => {
    dispatcher(includedActions.saveSuccess(savedID, data));
    dispatcher(includedActions.show(savedID));
    dispatcher(includedActions.showSuccess(savedID, data[0]));
    navigate(savedID);
  }));
};
const serverDeleteIssues = ids => async (dispatch, getState) => {
  try {
    await remove('/issues', null, ids);
  } catch (err) {
    return dispatch(tokenErrorActions.handleError(err, 'issue', () => {
      dispatch(notificationActions.error({
        message: err.message,
        id: 'server_delete_issues_failure'
      }, {
        autoClose: 2000
      }));
    }, serverDeleteIssues.bind(this, ids), handleRedirect));
  }
  const {
    issue
  } = getState();
  await dispatch(includedActions.serverIndex(issue.indexQuery, false));
  return dispatch(notificationActions.info({
    message: `Successfully deleted ${ids.length} issue${ids.length === 1 ? '' : 's'}.`
  }));
};
const serverSaveAssignments = (id, assignments) => async dispatch => {
  try {
    await post('/issues/assignments', assignments);
    dispatch(entityActions.selectClearAll());
    return dispatch(notificationActions.success({
      message: 'Successfully applied assignment changes.',
      id: `${id}_success`
    }, {
      autoClose: 2000
    }));
  } catch (e) {
    return dispatch(tokenErrorActions.handleError(e, 'issue', () => {
      dispatch(notificationActions.error({
        message: e.message,
        id: `${id}_failure`
      }, {
        autoClose: 2000
      }));
    }, serverSaveAssignments.bind(this, id, assignments), handleRedirect));
  }
};
const issueActions = _objectSpread(_objectSpread({}, includedActions), {}, {
  serverDeleteIssues,
  createIssuePhoto,
  indexByReport,
  serverSave,
  serverSaveAssignments,
  serverCreateIssue
});
export default issueActions;